<template>
    <div class="reset-wrap">
        <loginLayout>
            <div class="reset-form">
                <p class="ft24 cfff mb30">重置密码</p>
                <el-alert type="warning" :closable="false" v-if="routerPam.password_is_need_change.message">
                    <span slot="title"><i class="el-icon-warning mr5 dib"></i>提示：{{ routerPam.password_is_need_change.message }}</span>
                </el-alert>
                <el-form ref="resetForm" class="reset-form-con" size="small" label-width="140px" :model="resetForm" :rules="resetForm.rules">
                    <el-form-item label="用户名：" prop="user_name" :rules="{required: true,message:'请输入用户名'}">
                        <el-input
                            class="login-input"
                            :class="{'error-input': resetForm.errors.hasOwnProperty('user_name') && resetForm.errors.user_name.length > 0 }"
                            v-model="resetForm.user_name" 
                            placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码重置口令：" prop="password_update_code" :rules="{required:true,message:'密码重置口令'}">
                        <div class="flex flex-ac flex-pj">
                            <el-input 
                                class="login-input code-input"
                                :class="{'error-input': resetForm.errors.hasOwnProperty('password_update_code') && resetForm.errors.password_update_code.length > 0 }"
                                v-model="resetForm.password_update_code" 
                                placeholder="请输入口令"></el-input>
                            <div class="code-wrap" @click="getResetDingCode">
                                <span v-if="!resetForm.showTime" :class="{'disable-code-btn': resetForm.user_name === ''}" title="请先输入用户名" :disabled="resetForm.user_name === ''">获取口令</span>
                                <span class="time-tip ft12" v-else>{{ resetForm.time }}s后重新获取</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password" :rules="{required:true,message:'请输入新密码'}">
                        <span slot="label">
                            新密码
                            <el-tooltip class="item" effect="dark" content="最少需要6个字符,  需至少包含大写字母、小写字母、数字、特殊字符其中3种" placement="top">
                                <i class="el-icon-question cmain"></i>
                            </el-tooltip>：
                        </span>
                        <el-input
                            class="login-input"
                            :class="{'error-input': resetForm.errors.hasOwnProperty('password') && resetForm.errors.password.length > 0 }"
                            type="password" 
                            v-model="resetForm.password" 
                            placeholder="请输入新的密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="confirm_password">
                        <el-input 
                            class="login-input"
                            :class="{'error-input': resetForm.errors.hasOwnProperty('confirm_password') && resetForm.errors.confirm_password.length > 0 }"
                            type="password" v-model="resetForm.confirm_password" 
                            placeholder="请输入确认密码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="login-btn" @click="confirmReset">确认重置</div>
                        <span class="ml20 cfff cursor mt10" v-if="routerPam.password_is_need_change.ignore_not_pass" @click="ingoreReset">跳过</span>
                    </el-form-item>
                </el-form>
            </div>
        </loginLayout>
    </div>
</template>

<script>
    import jwtdecode from 'jwt-decode'
    import { commonApi } from '@/api/common'
    import loginLayout from './components/loginLayout.vue'
    export default {
        data() {
            const checkConfirmPwd = (rule, value, callback) => {
				if (this.resetForm.password != this.resetForm.confirm_password) {
					callback(new Error('两次输入密码不一致'))
				} else {
					callback()
				}
			}
            return {
                routerPam: {
                    name: '',
                    password: '',
                    referrer: '',
                    password_is_need_change: {
                        ignore_not_pass: false, //是否可以跳过
                        message: '', //提示文字
                    }
                },
                resetForm: {
                    orgId: 100,
                    user_name: '',
                    password_update_code: '',
                    password: '',
                    confirm_password: '',
                    showTime:false,//是否显示计时器
					time:60,
                    timeObj:null,//计时器
                    rules: {
                        confirm_password: [
                            { required:true, message:'请输入确认密码' },
                            { validator: checkConfirmPwd }
                        ]
                    },
                    errors: {
                        user_name: '',
                        password_update_code: '',
                        password: '',
                        confirm_password: '',
                    }
                }
            }
        },
        components: {
            loginLayout
        },
        beforeRouteEnter(to,form,next) {
			next(vm=>{
                vm.resetForm.user_name = vm.$EpetJs.Common.getRoute().user_name?vm.$EpetJs.Common.getRoute().user_name:''
                if(to.params && Object.keys(to.params).length>0) {
                    vm.routerPam.name = to.params.name
                    vm.routerPam.password = to.params.password
                    vm.routerPam.referrer = to.params.referrer?to.params.referrer:''
                    vm.routerPam.password_is_need_change.ignore_not_pass = to.params.password_is_need_change.ignore_not_pass
                    vm.routerPam.password_is_need_change.message = to.params.password_is_need_change.message
                }
				vm.clearData()
			})
		},
        methods: {
            //清除相关定时器
            clearTime() {
                clearInterval(this.resetForm.timeObj)
            },
            //清除相关数据
			clearData() {
				this.resetForm.showTime = false
				this.resetForm.time = 60
			},
            //获取重置密码口令
            getResetDingCode() {
                this.resetForm.time = 60
                this.resetForm.user_name = this.resetForm.user_name.trim()
                this.$EpetJs.Common.ajax('post',commonApi.getResetDingCodeUrl+'?user_name='+this.resetForm.user_name).then(res => {
                    if(res) {
                        this.resetForm.showTime = true
						this.resetForm.timeObj = setInterval(()=>{
							this.resetForm.time--
							if(this.resetForm.time == 0) {
								this.resetForm.showTime = false
								this.clearTime()
							}
						},1000)
                    }
                })
            },
            //确认重置密码
            confirmReset() {
                this.$refs.resetForm.validate(valid => {
                    if(valid) {
                        const pam = {
                            password_update_code: this.resetForm.password_update_code,
                            name: this.resetForm.user_name.trim(),
                            password: this.resetForm.password,
                            confirm_password: this.resetForm.confirm_password
                        }
                        this.$EpetJs.Common.ajax('post',commonApi.resetPwdUrl,pam).then(res => {
                            if(res) {
                                this.$message.success('修改成功！请重新登录,正在跳转登录页...')
                                setTimeout(_=>{
                                    this.$router.push('/login')
                                },500)
                            }
                        })
                    }
                })
            },
            //跳过重置密码，直接进入首页
            ingoreReset() {
                const pam = {
                    name: this.routerPam.name,
					password: this.routerPam.password,
					ac_type: 2,
					org_id: this.resetForm.orgId,
					platform: this.$store.state.platformName
                }
                this.$EpetJs.Common.ajax('post',commonApi.commonLogin+'?ignore_password_reset=true',pam).then(res => {
                    if(res) {
                        const userId = jwtdecode(res.data.data.token).user.uid
                        const acId = jwtdecode(res.data.data.token).user.acId
                        const expire = jwtdecode(res.data.data.token).exp
                        const user_name = jwtdecode(res.data.data.token).user.name
                        this.$store.commit('changeLoginState', {
                            isLogin: true
                        })
                        this.$store.commit('saveUser', {
                            userName: user_name,
                            userId: userId,
                            acId: acId
                        })
                        this.$store.commit('saveToken', {
                            token: res.data.data.token,
                            refreshToken: res.data.data.refreshToken,
                            expire: expire
                        })
                        if (this.routerPam.referrer) {
                            this.$router.replace(this.routerPam.referrer)
                        } else {
                            this.$router.replace('/')
                        }
                    }
                })  
            }
        }
    }
</script>

<style lang="less" scoped>
    .reset-wrap {
        /deep/.login-area {
            .login-content {
                margin-left: 10%;
            }
        }
        .reset-form {
            width: 416px;
            /deep/.el-form-item__error {
                display: none;
            }
            /deep/.el-form-item__label {
                color: #EBFAFF;
                font-size: 16px;
                line-height: 55px;
                &::before {
                    color: #EBFAFF;
                }
            }
            .el-icon-question {
                color: #7a9dec;
                font-size: 25px;
                vertical-align: -4px;
            }
            .login-input {
                /deep/.el-input__inner {
                    color: #ffffff;
                    font-size: 14px;
                    height: 55px;
                    line-height: 55px;
                    padding-left: 30px;
                    background: rgba(255,255,255,0.08);
                    box-shadow: inset 0px 5px 15px 0px rgba(34,84,204,0.4);
                    border-radius: 30px;
                    border: 1px solid rgba(253,253,253,0.8);
                    &::-webkit-input-placeholder {
                        color: #B9D1F8;
                    }
                    &:focus {
                        border: 2px solid rgba(253,253,253,1);
                    }
                }
                /deep/.el-input__prefix {
                    padding-left: 18px;
                    margin: 2px 12px 0 0;
                    .el-input__icon {
                        font-size: 25px;
                        color: #B9D1F8;
                    }
                }
                &.error-input {
                    /deep/.el-input__inner {
                        &::-webkit-input-placeholder {
                            color: #ffffff;
                        }
                    }
                }
            }
            .code-input {
                width: 170px;
            }
            .code-wrap {
                display: inline-block;
                width: 100px;
                height: 55px;
                line-height: 55px;
                text-align: center;
                background: rgba(255, 255, 255, .3);
                color: #EBFAFF;
                cursor: pointer;
                border-radius: 30px;
                border: 1px solid rgba(253,253,253,0.8);
            }
            .disable-code-btn {
                cursor: not-allowed;
            }
            .code-wrap {
                display: inline-block;
                height: 55px;
                line-height: 55px;
                text-align: center;
                background: rgba(255, 255, 255, .3);
                color: #EBFAFF;
                cursor: pointer;
                border-radius: 30px;
                border: 1px solid rgba(253,253,253,0.8);
            }
            .login-btn {
                width: 100%;
                height: 55px;
                border-radius: 30px;
                line-height: 55px;
                text-align: center;
                cursor: pointer;
                color: #ffffff;
                font-size: 20px;
                background: linear-gradient(90deg, #00C0FA, #537DFB);
                box-shadow: 0px 15px 25px 0px rgba(1,52,215,0.3);
                &:hover {
                    background: linear-gradient(90deg, #68E0CF, #209CFF);
                }
            }
        }
	}
</style>